import React from 'react'

import cn from 'classnames'

import styles from './ScreenReaderOnlyText.module.scss'
import { ScreenReaderOnlyTextProps } from './types'

const ScreenReaderOnlyText: React.FC<ScreenReaderOnlyTextProps> = ({
  children,
  Tag = 'span',
  className,
  ...props
}) => (
  <Tag className={cn(styles.container, className)} {...props}>
    {children}
  </Tag>
)

export default ScreenReaderOnlyText
